<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    /><path
      class="b"
      d="M6.941 6.533l11.253-.026V3.668a.657.657 0 00-.669-.67H3.668a.657.657 0 00-.668.67v9.645a.657.657 0 00.669.669h2.62l-.017-6.784a.657.657 0 01.669-.668z"
    /><path
      class="b"
      d="M20.8 6.518H6.943a.657.657 0 00-.669.669v9.646a.657.657 0 00.669.669h5.971l2.985 3.275a.715.715 0 00.49.223.491.491 0 00.178-.023.683.683 0 00.49-.49l.672-2.985h3.07a.657.657 0 00.669-.669V7.187a.657.657 0 00-.669-.669z"
    />
  </g>
</template>
<style scoped>
.b{fill:none;stroke:currentColor;stroke-width:1.7px}
</style>